// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPhoneEdition__container___1mSmv","prefix-input":"UserPhoneEdition__prefix-input___2qBb0"};